<ion-card>
  <ion-card-header>
    <ion-card-title>Keresés az iratanyagban</ion-card-title>
    <ion-card-subtitle>
      Iktatószám, tárgy, partner, hivatkozási szám – és a csatolt fájlok neve is.
      Csak azt találod meg, amihez hozzáférésed van.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-searchbar placeholder="Mit keresel?" [(ngModel)]="q" [debounce]="350"
                     (ionChange)="keres()" (keyup.enter)="keres()" style="max-width:520px"></ion-searchbar>
      <ion-button size="small" (click)="keres()">
        <ion-icon slot="start" name="search-outline"></ion-icon>Keresés
      </ion-button>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <ng-container *ngIf="keresve && !betoltes">
      <h3 style="font-size:.95rem;margin:12px 0 6px">
        Ügyiratok <ion-badge color="medium">{{ ugyiratok.length }}</ion-badge>
      </h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Iktatószám</th><th>Tárgy</th><th>Ügyintéző</th><th>Állapot</th><th>Határidő</th></tr></thead>
          <tbody>
            <tr *ngFor="let u of ugyiratok" (click)="ugyiratra(u)" style="cursor:pointer">
              <td class="iktszam">{{ u.iktatoszam }}</td>
              <td>{{ u.targy }}</td>
              <td>{{ u.ugyintezo || '–' }}</td>
              <td><ion-badge color="medium">{{ u.allapot }}</ion-badge></td>
              <td class="szam">{{ u.hatarido || '–' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!ugyiratok.length">Nincs találat az ügyiratok között.</div>
      </div>

      <h3 style="font-size:.95rem;margin:16px 0 6px">
        Iratok <ion-badge color="medium">{{ iratok.length }}</ion-badge>
      </h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Iktatószám</th><th>Irány</th><th>Tárgy</th><th>Partner</th><th>Iktatva</th></tr></thead>
          <tbody>
            <tr *ngFor="let i of iratok" (click)="iratra(i)" style="cursor:pointer">
              <td class="iktszam">{{ i.iktatoszam }}</td>
              <td>{{ i.irany === 'be' ? 'bejövő' : 'kimenő' }}</td>
              <td>{{ i.targy }}</td>
              <td>{{ i.partner_nev || '–' }}</td>
              <td class="szam">{{ i.iktatva }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!iratok.length">Nincs találat az iratok között.</div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
